import React from 'react';
import ShowQuery from 'queries/inspection_subject/show';
import ShowItem from 'components/inspection_subject/show_item';
import Loader from 'components/loader';
import InspectionsContainer from 'components/inspection/index_container';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Container from 'components/layout/container';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { InspectionSubjectsLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import { WhiteCard } from 'components/styles_components/card';
import { Typography } from 'components/ui';

const Show = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { inspectionSubjectId } = useParams();
  const {
    data = { inspectionSubject: { adminRole: true, inspectionsTotal: 0, place: {} } },
    loading,
    error,
    refetch,
  } = useQuery(ShowQuery, {
    variables: { id: inspectionSubjectId },
    onError: () => {
      setError('error.inspection_subject.show');
      navigate(InspectionSubjectsLink());
    },
  });

  if (loading || error) {
    return <Loader />;
  }

  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbLink to={InspectionSubjectsLink()}>
          <FormattedMessage id="breadcrumb.inspection_subjects.index" />
        </BreadCrumbLink>
        <BreadCrumbTypography>{data.inspectionSubject.name}</BreadCrumbTypography>
      </BreadcrumbContainer>
      <ShowItem inspectionSubject={data.inspectionSubject} space={data.space} refetch={refetch} />
      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="inspection.count" />
        </Typography>
        <PaginateProvider key="inspections-tab">
          <InspectionsContainer
            overInspectionsLimit={data.space.overInspectionsLimit}
            adminRole={data.space.adminRole}
            placeId={data.inspectionSubject.place.id}
            inspectionSubjectId={inspectionSubjectId}
          />
        </PaginateProvider>
      </WhiteCard>
    </Container>
  );
};

export default Show;
